import { render, staticRenderFns } from "./500.vue?vue&type=template&id=22cc5c87"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"
import style0 from "./500.vue?vue&type=style&index=0&id=22cc5c87&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports